
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    rule: {
        borderBottom: '1px solid #DBDBDB'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/Rule/styles.js